document.querySelectorAll('div[data-anchor-links] a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const element = document.querySelector(this.getAttribute('href'));
        const rect = element.getBoundingClientRect();

        const yOffset = document.querySelector('#topnav').getBoundingClientRect().height;
        const top = rect.top + window.scrollY - yOffset - rect.height / 2;

        window.scrollTo({top, behavior: 'smooth'});
    });
});
